var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Col, Media } from "react-bootstrap";
import { injectIntl } from "@irati/utils/lang";
import { Para } from "../Labels";
import { Card } from "./styled";
var CardImage = /** @class */ (function (_super) {
    __extends(CardImage, _super);
    function CardImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardImage.prototype.render = function () {
        var _a = this.props, colSize = _a.colSize, description = _a.description, imageAlt = _a.imageAlt, imageSrc = _a.imageSrc, imagePosition = _a.imagePosition, imageSize = _a.imageSize, rollover = _a.rollover, title = _a.title;
        return (React.createElement(Col, { md: colSize },
            React.createElement(Card, { small: true, rollover: rollover },
                React.createElement(Media, null,
                    imagePosition === "left" && React.createElement(Media.Left, { align: "middle" },
                        React.createElement("img", { width: imageSize, height: imageSize, src: imageSrc, alt: imageAlt })),
                    React.createElement(Media.Body, null,
                        React.createElement(Media.Heading, null, title),
                        React.createElement(Para, null, description)),
                    imagePosition === "right" && React.createElement(Media.Right, { align: "middle" },
                        React.createElement("img", { width: imageSize, height: imageSize, src: imageSrc, alt: imageAlt }))))));
    };
    return CardImage;
}(PureComponent));
export default injectIntl(CardImage);
